import config from '../../config';

export default {
  url: `${config.api.baseURL}/search?q=:term`,
  transformer(data) {
    return data;
  }
};
